export default "/images/logo-text.png?2453f70343a3defc108fa2be1a9355de";